import { supabase } from '../lib/supabase';

export const notificationService = {
  /** Fetch all notifications for the current user */
  async getAll() {
    const { data, error } = await supabase?.from('notifications')?.select('*')?.order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  /** Mark a single notification as read */
  async markRead(id) {
    const { error } = await supabase?.from('notifications')?.update({ is_read: true })?.eq('id', id);
    if (error) throw error;
  },

  /** Mark all notifications as read for current user */
  async markAllRead() {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) return;
    const { error } = await supabase?.from('notifications')?.update({ is_read: true })?.eq('user_id', user?.id)?.eq('is_read', false);
    if (error) throw error;
  },

  /** Delete a notification */
  async delete(id) {
    const { error } = await supabase?.from('notifications')?.delete()?.eq('id', id);
    if (error) throw error;
  },

  /** Subscribe to real-time notification inserts for the current user */
  subscribeToNew(userId, callback) {
    return supabase?.channel(`notifications:${userId}`)?.on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'notifications',
          filter: `user_id=eq.${userId}`,
        },
        (payload) => callback(payload?.new)
      )?.subscribe();
  },

  /** Unsubscribe from a channel */
  unsubscribe(channel) {
    if (channel) supabase?.removeChannel(channel);
  },
};
